export default {
  navHome: "होम",
  navProducts: "उत्पाद",
  navCases: "अनुप्रयोग केस",
  navAbout: "हमारे बारे में",
  deliverTo: "डिलीवर करें:",
  langCurrencyLabel: "हिंदी",
  localeLangTitle: "भाषा सेट करें",
  localeLangDesc: "अपनी पसंदीदा भाषा चुनें। आप किसी भी समय इस सेटिंग को अपडेट कर सकते हैं।",
  language: "भाषा",
  save: "सहेजें",
  coreProducts: "वास्तविक दुनिया में रचनात्मकता को सशक्त बनाना।",
  coreProductsDesc: "विचार से व्यवसाय तक — YONGYUAN UV प्रिंटर, क्रिस्टल लेबल प्रिंटर, उच्च गति सिलेंड्रिकल प्रिंटर, DTF और DTG प्रिंटर प्रदान करता है, रचनात्मकता को उत्पादों, ब्रांडों और अवसरों में बदलता है।",
  scenariosTitle: "हर परिदृश्य के लिए समाधान",
  scenariosDesc: "चाहे आप ब्रांड बना रहे हों, साइड बिज़नेस विकसित कर रहे हों या रचनात्मक जुनून का पालन कर रहे हों, YONGYUAN आपकी ज़रूरतों के अनुरूप समाधान प्रदान करता है।",
  scenarioStudio: "स्टूडियो",
  scenarioStudioDesc: "उच्च मूल्य अनुकूलन, छोटे बैच प्रोटोटाइपिंग और ब्रांड निर्माण",
  scenarioRetail: "ब्रांड रिटेल",
  scenarioRetailDesc: "ग्राहक ठहरने का समय बढ़ाएं और स्टोर राजस्व बढ़ाएं",
  scenarioMarket: "पॉप-अप मार्केट",
  scenarioMarketDesc: "ऑन-साइट अनुकूलन, तैयार उत्पाद बिक्री और अतिरिक्त आय",
  scenarioEnterprise: "एंटरप्राइज़ अनुकूलन",
  scenarioEnterpriseDesc: "बैच अनुकूलन, ब्रांडेड मर्चेंडाइज़ और कॉर्पोरेट उपहार",
  scenarioEcommerce: "लाइवस्ट्रीम बिक्री",
  scenarioEcommerceDesc: "हिट उत्पाद सैंपलिंग, लचीली आपूर्ति और तेज़ उत्पाद लॉन्च",
  scenarioStore: "ई-कॉमर्स स्टोर",
  scenarioStoreDesc: "स्टोर अनुकूलन, हिट मर्चेंडाइज़ और भिन्न संचालन",
  scenarioFactory: "फैक्टरी उत्पादन",
  scenarioFactoryDesc: "बैच निर्माण, स्थिर आउटपुट और लागत-कुशल संचालन",
  scenarioAdvertising: "विज्ञापन उत्पादन",
  scenarioAdvertisingDesc: "साइनेज, डिस्प्ले सामग्री और इवेंट सामग्री",
  industries: "उद्योग अनुप्रयोग",
  industriesDesc: "विभिन्न उद्योगों में रंगीन मुद्रण के लिए डिजिटल इंकजेट प्रिंटिंग समाधान।",
  applicationsTitle: "दैनिक और व्यावसायिक ज़रूरतों के लिए बहुमुखी सामग्री और रंग अनुप्रयोग।",
  applicationsDesc: "YONGYUAN UV प्रिंटिंग उपकरण विभिन्न सामग्रियों और प्रक्रिया परिदृश्यों के लिए डिज़ाइन किए गए हैं, व्यक्तिगत अनुकूलन और बड़े पैमाने पर उत्पादन को सशक्त बनाते हैं।",
  casesHeroDesc: "1200+ उद्योग अनुप्रयोग और हजारों प्रकार की छपाई योग्य सामग्री — विभिन्न व्यवसायों के लिए डिजिटल प्रिंटिंग समाधान।",
  casesBreadcrumbHome: "होम",
  casesBreadcrumbCenter: "अनुप्रयोग केस",
  casesEmpty: "इस श्रेणी में अभी कोई अनुप्रयोग केस नहीं है।",
  customerStoriesTitle: "दुनिया भर के ग्राहकों द्वारा विश्वसनीय",
  customerStoriesSubtitle: "172 देशों में वास्तविक इंस्टॉलेशन, वास्तविक ग्राहक, वास्तविक प्रिंटिंग व्यवसाय।",
  customerStoriesStat1Value: "53,000+",
  customerStoriesStat1Label: "डिलीवर किए गए प्रिंटर",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "सेवा प्रदान देश",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "वर्षों का अनुभव",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "तकनीकी सहायता",
  customerStoriesPlaceholder: "ग्राहक फोटो जोड़ें",
  customerStoriesPhotoAlt: "YONGYUAN ग्राहक प्रिंटर के साथ",
  servicePartnerTitle: "YONGYUAN सेवा टीम से मिलें, आपका रचनात्मक साझीदार",
  servicePartnerDesc: "आपके उपकरण प्रदर्शन और व्यवसाय विकास की रक्षा के लिए वैश्विक सेवा नेटवर्क और पेशेवर सहायता प्रणाली।",
  serviceSupportTitle: "मानक सहायता",
  serviceSupportDesc: "स्थापना मार्गदर्शन, बुनियादी प्रशिक्षण और दैनिक उपयोग सहायता विश्वसनीय संचालन के लिए।",
  servicePresaleTitle: "प्री-सेल्स डेमो और परामर्श",
  servicePresaleDesc: "आपके अनुप्रयोग परिदृश्यों और क्षमता आवश्यकताओं के अनुरूप समाधान प्रदर्शन और मॉडल सिफारिशें।",
  serviceLifetimeTitle: "आजीवन तकनीकी सहायता",
  serviceLifetimeDesc: "आपके दीर्घकालिक व्यवसाय विकास के साथ निरंतर तकनीकी प्रतिक्रिया और प्रक्रिया सहायता।",
  serviceCareTitle: "YONGYUAN Care में अपग्रेड करें",
  serviceCareDamageTitle: "आकस्मिक क्षति सुरक्षा",
  serviceCareDamageDesc: "अप्रत्याशित घटनाओं से होने वाले नुकसान को कम करने के लिए अधिक व्यापक सुरक्षा योजना।",
  serviceCareExchangeTitle: "तेज़ ट्रेड-इन सेवा",
  serviceCareExchangeDesc: "पूंजी पुनर्प्राप्ति तेज़ करने के लिए पात्र शर्तों में प्राथमिकता तेज़ ट्रेड-इन व्यवस्था।",
  viewProduct: "उत्पाद देखें",
  learnMore: "और जानें",
  catUv: "UV फ्लैटबेड प्रिंटर",
  catCylinder: "सिलेंड्रिकल प्रिंटर",
  catCrystal: "क्रिस्टल लेबल प्रिंटर",
  catDtf: "DTF प्रिंटर",
  catDtg: "DTG प्रिंटर",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "फ़ोन: 17748697567 मैनेजर टैंग",
  email: "ईमेल: sales@yongyuanprinter.com",
  copyright: "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. सर्वाधिकार सुरक्षित",
  productsHeroTitle: "उत्पाद",
  productsHeroDesc: "विविध क्षमता और अनुप्रयोग आवश्यकताओं के लिए UV फ्लैटबेड, सिलेंड्रिकल, क्रिस्टल लेबल, DTF और DTG उपकरणों की पूरी श्रृंखला।",
  productsBreadcrumbHome: "होम",
  productsBreadcrumbCenter: "उत्पाद",
  productsEmpty: "इस श्रेणी के उत्पाद जल्द ही उपलब्ध होंगे।",
  productsQuoteTitle: "समाधान और कोटेशन अनुरोध करें",
  productsQuoteDesc: "अपने अनुप्रयोग परिदृश्य और क्षमता आवश्यकताएं साझा करें, हम उपयुक्त उपकरण समाधान की सिफारिश करेंगे।",
  productsContact: "संपर्क करें",
  aboutHeroTitle: "Yongyuan के बारे में",
  aboutHeroDesc: "UV प्रिंटिंग उपकरण अनुसंधान, विकास और उत्पादन में 23 वर्षों का फोकस",
  productA23Subtitle: "डेस्कटॉप 6-रंग बुद्धिमान UV प्रिंटर",
  productA23Feature1: "A4 प्रिंट प्रारूप",
  productA23Feature2: "बुद्धिमान स्याही वितरण प्रणाली",
  productA23Feature3: "इन्फ्रारेड स्वचालित ऊंचाई पहचान",
  productA35Subtitle: "डेस्कटॉप 6-रंग बुद्धिमान UV प्रिंटर",
  productA35Feature1: "A3+ प्रिंट प्रारूप",
  productA35Feature2: "बुद्धिमान स्याही वितरण प्रणाली",
  productA35Feature3: "इन्फ्रारेड स्वचालित ऊंचाई पहचान",
  productA43Subtitle: "फ्लैगशिप 8-रंग बुद्धिमान UV प्रिंटर",
  productA43Feature1: "A3 प्रिंट प्रारूप",
  productA43Feature2: "कई प्रिंटहेड कॉन्फ़िगरेशन",
  productA43Feature3: "बुद्धिमान स्याही वितरण प्रणाली",
  productA46Subtitle: "फ्लैगशिप 8-रंग बुद्धिमान UV प्रिंटर",
  productA46Feature1: "A2 प्रिंट प्रारूप",
  productA46Feature2: "कई प्रिंटहेड कॉन्फ़िगरेशन",
  productA46Feature3: "बुद्धिमान स्याही वितरण प्रणाली",
  productA57Subtitle: "फ्लैगशिप 8-रंग बुद्धिमान UV प्रिंटर",
  productA57Feature1: "A2+ प्रिंट प्रारूप",
  productA57Feature2: "कई प्रिंटहेड कॉन्फ़िगरेशन",
  productA57Feature3: "बुद्धिमान स्याही वितरण प्रणाली",
  productA69Subtitle: "फ्लैगशिप 8-रंग बुद्धिमान UV प्रिंटर",
  productA69Feature1: "A1 प्रिंट प्रारूप",
  productA69Feature2: "कई प्रिंटहेड कॉन्फ़िगरेशन",
  productA69Feature3: "बुद्धिमान स्याही वितरण प्रणाली",
  productA1216Subtitle: "फ्लैगशिप बड़े प्रारूप UV फ्लैटबेड प्रिंटर",
  productA1216Feature1: "1200×1600cm प्रिंट प्रारूप",
  productA1216Feature2: "कई प्रिंटहेड कॉन्फ़िगरेशन",
  productA1216Feature3: "दृश्य स्थिति प्रणाली",
  productA2513Subtitle: "फ्लैगशिप बड़े प्रारूप UV फ्लैटबेड प्रिंटर",
  productA2513Feature1: "2500×1300cm प्रिंट प्रारूप",
  productA2513Feature2: "कई प्रिंटहेड कॉन्फ़िगरेशन",
  productA2513Feature3: "दृश्य स्थिति प्रणाली",
  productCylinderElfSubtitle: "360° उच्च गति सिलेंड्रिकल प्रिंटर",
  productCylinderElfFeature1: "360° प्रिंटिंग",
  productCylinderElfFeature2: "कप और बोतल अनुकूलन",
  productCylinderElfFeature3: "त्वरित फिक्सचर परिवर्तन",
  productCupPlusSubtitle: "मल्टी-साइज़ कप और बोतल प्रिंटिंग समाधान",
  productCupPlusFeature1: "मल्टी-साइज़ फिक्सचर",
  productCupPlusFeature2: "उच्च उत्पादन दक्षता",
  productCupPlusFeature3: "स्थिर आउटपुट",
  productCrystal60Subtitle: "क्रिस्टल लेबल प्रिंट और फॉइल ऑल-इन-वन सिस्टम",
  productCrystal60Feature1: "60cm चौड़ाई",
  productCrystal60Feature2: "प्रिंट और फॉइल एकीकरण",
  productCrystal60Feature3: "कुशल टेक-अप प्रणाली",
  productCrystalC60UltraFeature1: "60 सेमी चौड़ाई",
  productCrystalC60UltraFeature2: "गोल्ड/सिल्वर/3D सिलicone लेबल विकल्प",
  productCrystalC60UltraFeature3: "बड़े पैमाने पर उत्पादन",
  productCrystal30Subtitle: "कॉम्पैक्ट उच्च-सटीकता क्रिस्टल लेबल प्रिंटर",
  productCrystal30Feature1: "कॉम्पैक्ट सटीक प्रिंटिंग",
  productCrystal30Feature2: "आसान संचालन",
  productCrystal30Feature3: "व्यक्तिगत अनुकूलन",
  productDtf60Subtitle: "व्हाइट इंक DTF ट्रांसफर प्रिंटर",
  productDtf60Feature1: "व्हाइट इंक DTF ट्रांसफर",
  productDtf60Feature2: "समृद्ध रंग परतें",
  productDtf60Feature3: "परिधान सहायक सामग्री",
  productDtfF20Subtitle: "उद्योग की सबसे छोटी डेस्कटॉप व्हाइट इंक DTF प्रिंटर",
  productDtfF20Feature1: "A4 आकार",
  productDtfF20Feature2: "छोटे बैच अनुकूलन",
  productDtfF20Feature3: "स्मार्ट इंक सिस्टम",
  productDtfF30Subtitle: "डेस्कटॉप व्हाइट इंक DTF प्रिंटर",
  productDtfF30Feature1: "A3 आकार",
  productDtfF30Feature2: "सिंगल हेड मैनुअल/ऑटो विकल्प",
  productDtfF30Feature3: "स्मार्ट इंक सिस्टम",
  productDtfF30ProSubtitle: "व्हाइट इंक DTF प्रिंटर",
  productDtfF30ProFeature1: "A3 आकार",
  productDtfF30ProFeature2: "डुअल हेड ऑटो फिल्म टेक-अप",
  productDtfF30ProFeature3: "स्मार्ट इंक सिस्टम",
  productDtfF33Subtitle: "व्हाइट इंक DTF प्रिंटर",
  productDtfF33Feature1: "A3 आकार",
  productDtfF33Feature2: "सिंगल हेड मैनुअल/ऑटो विकल्प",
  productDtfF33Feature3: "स्मार्ट इंक सिस्टम",
  productDtfF70ProSubtitle: "70 सेमी वाइड-फॉर्मैट व्हाइट इंक DTF प्रिंटर",
  productDtfF70ProFeature1: "A2 आकार",
  productDtfF70ProFeature2: "2–4 प्रिंटहेड विकल्प",
  productDtfF70ProFeature3: "ऑटो फीड और डिस्चार्ज सिस्टम",
  productDtfF70ProFeature4: "स्मार्ट रिज्यूम प्रिंटिंग मोड",
  productDtf30Subtitle: "कॉम्पैक्ट व्हाइट इंक DTF प्रिंटर",
  productDtf30Feature1: "छोटे बैच अनुकूलन",
  productDtf30Feature2: "सटीक रंग प्रजनन",
  productDtf30Feature3: "उपयोग में आसान",
  productDtgPrintSubtitle: "डिजिटल डायरेक्ट-टू-गारमेंट प्रिंटर",
  productDtgPrintFeature1: "मल्टी-मटेरियल डायरेक्ट प्रिंटिंग",
  productDtgPrintFeature2: "उच्च थ्रूपुट",
  productDtgPrintFeature3: "स्थिर और टिकाऊ",
  productDtg3250DSubtitle: "उद्योग का एकमात्र DTF और DTG 2-इन-1 मॉडल",
  productDtg3250DFeature1: "A3+ फॉर्मैट",
  productDtg3250DFeature2: "DTF और DTG दोहरी प्रक्रिया प्रिंटिंग",
  productDtg3250DFeature3: "स्मार्ट इंक सिस्टम",
  productDtg3646TSubtitle: "डुअल-स्टेशन DTG प्रिंटर",
  productDtg3646TFeature1: "निरंतर उत्पादन मोड",
  productDtg3646TFeature2: "100% उत्पादकता वृद्धि",
  productDtg3646TFeature3: "स्मार्ट इंक सिस्टम",
  productDtgMaxSubtitle: "औद्योगिक डिजिटल DTG प्रिंटर",
  productDtgMaxFeature1: "औद्योगिक क्षमता",
  productDtgMaxFeature2: "स्थिर और टिकाऊ",
  productDtgMaxFeature3: "निरंतर संचालन",
  app01Title: "फ़ोन केस",
  app02Title: "गोल्फ बॉल",
  app03Title: "पत्थर की प्लेटें",
  app04Title: "बॉलपॉइंट पेन",
  app05Title: "चश्मा केस",
  app06Title: "लकड़ी की छपाई",
  app07Title: "पेय कैन",
  app08Title: "कीबोर्ड",
  app09Title: "टंबलर",
  app10Title: "सामान",
  app11Title: "एक्रिलिक उत्पाद",
  app12Title: "नोटबुक",
  app13Title: "बैज",
  app14Title: "चमड़े के कार्ड होल्डर",
  app15Title: "डॉग टैग",
  app16Title: "कांच कला",
  appDtgCase01: "टी-शर्ट",
  appDtgCase02: "हुडी",
  regionCn: "चीन",
  regionUs: "संयुक्त राज्य अमेरिका",
  regionGb: "यूनाइटेड किंगडम",
  regionDe: "जर्मनी",
  regionAe: "यूएई",
  regionIn: "भारत",
  regionJp: "जापान",
  regionVn: "वियतनाम",
  regionBr: "ब्राज़ील",
  regionAu: "ऑस्ट्रेलिया",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
